
<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center">
        <div class="vx-col md:w-1/2 lg:w-2/5 m-4">
            <vx-card v-if="rendered">
                <div class="vx-card__title mb-6">
                    <h2 class="text-center">{{ invite.name }}, você recebeu um convite!</h2>
                </div>

                <img :src="invite.logo" alt="coming-soon" class="mx-auto mb-2" width="150">

                <vs-divider position="center"><feather-icon icon="ArrowDownIcon" svgClasses="h-4" > </feather-icon> ACEITE O CONVITE <feather-icon icon="ArrowDownIcon" svgClasses="h-4" > </feather-icon></vs-divider>

                <div>

                    <span>A empresa <strong>{{ invite.companyName }}</strong> te convidou para ingressar nos quadros de seus colaboradores.</span>
                    <p class="mt-4">Ao aceitar o convite, você será alocado para a função de <strong>{{ roleName }}</strong>.</p>
                    <vs-button :disabled="!acceptBtnEnabled" color="danger" type="relief" class="w-full mt-4" @click="acceptInvite()">Aceitar convite</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>


<script>
import firebase from '@/firebase/firebase'
import employeeRoles from '@/components/account/employeeRoles.js'

export default {
    props : {
        invitationId: {
            required: true
        },
        companyId: {
            required: true
        }
    },

    data() {
        return {
            acceptBtnEnabled : true,
            availableRoles : [],
            roleName : 'Desconhecido',
            rendered : false,
            invite : {
                name : '',
                companyName: '',
                role: 2,
            }
        }
    },

    created () {
        this.getInvitationFromDB()
        this.availableRoles = employeeRoles.availableEmployeeRoles()
    },

    methods : {
        async acceptInvite () {
            if(this.acceptBtnEnabled)
                try {
                    this.$vs.loading()
                    await firebase.firestore().collection('company').doc(this.companyId).collection('employeeRequests').doc(this.invitationId).update({ active: false, accepted: true })
                    
                    let userObj = await this.removeTrashFields()
                    await firebase.firestore().collection('company').doc(this.companyId).collection('companyUsers').doc(this.invite.uid).set(this.invite)

                    this.acceptBtnEnabled = false
                    this.$vs.dialog({
                        type: 'alert',
                        title: 'Seja bem-vindo!',
                        text: 'Parabéns! Agora você também faz parte desta empresa. Faça o login para começar a trabalhar!',
                        acceptText: 'Obrigado!'
                    })
                    this.$router.push('/login/')
                } catch (err) {
                    this.$vs.dialog({
                        type: 'alert',
                        title: 'Erro!',
                        text: `Ocorreu um erro ao tentar aceitar o convite: ${err.message}`,
                        acceptText: 'Fechar'
                    })
                } finally {
                    this.$vs.loading.close()
                }      
        },

        removeTrashFields () {
            return new Promise(resolve => {
                this.$set(this.invite, 'blocked', false)
                this.$set(this.invite, 'main', false)
                this.$delete(this.invite, 'companyName')
                this.$delete(this.invite, 'active')
                this.$delete(this.invite, 'accepted')
                this.$delete(this.invite, 'emailVerified')
                this.$delete(this.invite, 'companyLogo')
                this.$delete(this.invite, 'createdOn')
                this.$delete(this.invite, 'isAnonymous')
                if(this.invite.hasOwnProperty('providerData')) this.$delete(this.invite, 'providerData')

                resolve(this.invite)
            })
        },

        async getInvitationFromDB () {
            try {
                this.$vs.loading()
                let invitation = await firebase.firestore().collection('company').doc(this.companyId).collection('employeeRequests').doc(this.invitationId).get()

                
                if(invitation.exists) {
                    this.invite = invitation.data()
                    if(!this.invite.active) {
                        this.$vs.dialog({
                            type: 'alert',
                            title: 'Erro',
                            text: 'O convite não é válido!',
                            acceptText: 'Fechar'
                        })
                        this.$router.push('/login/')
                    }
                    this.getRoleName()
                } else {
                    this.$vs.dialog({
                        type: 'alert',
                        title: 'Erro',
                        text: 'O convite não existe!',
                        acceptText: 'Fechar'
                    })
                    this.$router.push('/login/')
                }

                let company    = (await firebase.firestore().collection('company').doc(this.companyId).get()).data()
                this.invite.companyName = company.name
                this.invite.companyLogo = company.logo

                this.rendered = true
            } catch (err) {
                console.log(err.message)
            } finally {
                this.$vs.loading.close()
            }
        },

        getRoleName () {
            this.availableRoles.forEach(k => {
                if(k.value == this.invite.role) {
                    this.roleName = k.label
                    return
                }
            })
        },
    }
}

</script>
